// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("../DateFns/DateFns.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var DateFns$1 = require("date-fns");

function hours(prim) {
  return DateFns$1.getHours(prim);
}

function minutes(prim) {
  return DateFns$1.getMinutes(prim);
}

function make(hour, minute) {
  return DateFns$1.setMinutes(DateFns$1.setHours(new Date(), hour), minute);
}

var cmp = Caml_obj.compare;

function to12HourString(t) {
  return DateFns$1.format(t, "h:mm aaa");
}

function to24HourString(t) {
  return DateFns$1.format(t, "H:mm");
}

function fromDate(t) {
  return t;
}

function decode(s) {
  return DateFns.parse(s, "h:mm aaa", new Date());
}

var encode = to12HourString;

exports.make = make;
exports.hours = hours;
exports.minutes = minutes;
exports.cmp = cmp;
exports.to12HourString = to12HourString;
exports.to24HourString = to24HourString;
exports.fromDate = fromDate;
exports.encode = encode;
exports.decode = decode;
/* DateFns Not a pure module */
